__webpack_require__.p = "https://design-editor.test.gelato.tech/";